import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      <p>Jiří Smolek - 2026</p>
    </footer>
  );
};

export default Footer;
